import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Text } from "@cinch-labs/design-system";
import { getDayMonthYearFormat } from "@cinch-labs/shared-util";
import { TrackingEventTypes, useAnalytics } from "@cinch-nx/shared-analytics";
import cx from "classnames";
import styles from "./trustpilot-review-card.module.css";
const ReviewCard = ({ starRating , title , description , customerName , date , link  })=>{
    const { trackEvent  } = useAnalytics();
    const trackClick = ()=>{
        trackEvent({
            eventName: "trustpilot review",
            type: TrackingEventTypes.ADOBE,
            data: {
                event: {
                    name: "click",
                    category: "button",
                    label: `trustpilot review cards`,
                    action: `click on review card`,
                    value: "full review"
                }
            }
        });
    };
    return /*#__PURE__*/ _jsx("a", {
        href: link,
        target: "_blank",
        rel: "noreferrer",
        "data-testid": "review-card",
        className: styles.trustpilotReviewLink,
        onClick: trackClick,
        children: /*#__PURE__*/ _jsxs("div", {
            className: styles.reviewCardContainer,
            children: [
                /*#__PURE__*/ _jsxs("div", {
                    children: [
                        /*#__PURE__*/ _jsx("div", {
                            className: styles.starRatingContainer,
                            role: "figure",
                            "aria-label": `${starRating} of 5 rating`,
                            children: [
                                ...Array.from({
                                    length: 5
                                })
                            ].map((_, i)=>/*#__PURE__*/ _jsx("span", {
                                    className: cx(styles.starRatingIconContainer, {
                                        [styles.starRatingIconContainerFilled]: i + 1 <= starRating
                                    }),
                                    children: /*#__PURE__*/ _jsx("svg", {
                                        fill: "none",
                                        xmlns: "http://www.w3.org/2000/svg",
                                        className: styles.starRatingIcon,
                                        children: /*#__PURE__*/ _jsx("path", {
                                            d: "m11.469 15.893 4.705-1.195 1.966 6.07-6.671-4.875Zm10.828-7.847h-8.282L11.469.23 8.923 8.046H.64l6.703 4.844-2.546 7.814L11.5 15.86l4.125-2.97 6.67-4.844Z",
                                            fill: "#fff"
                                        })
                                    })
                                }, i))
                        }),
                        /*#__PURE__*/ _jsx(Text, {
                            fontSize: "xl",
                            fontWeight: "bold",
                            className: styles.trustPilotTitle,
                            children: title
                        }),
                        /*#__PURE__*/ _jsx(Text, {
                            fontWeight: "medium",
                            className: styles.trustPilotDescription,
                            children: description
                        })
                    ]
                }),
                /*#__PURE__*/ _jsxs("div", {
                    children: [
                        /*#__PURE__*/ _jsx(Text, {
                            fontWeight: "bold",
                            className: styles.trustPilotCustomerName,
                            children: customerName
                        }),
                        /*#__PURE__*/ _jsx(Text, {
                            fontSize: "m",
                            fontWeight: "medium",
                            className: styles.trustPilotDate,
                            children: getDayMonthYearFormat(date)
                        })
                    ]
                })
            ]
        })
    });
};
export default ReviewCard;
